var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grey mb-4 navtop page-title"},[_c('b-container',{staticClass:"py-3 text-center"},[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }